<template>
  <div class="vp-h-full">
    <!-- Header Buttons -->
    <VpHeaderActions>
      <VpAddItem :feature="feature" route="quick-reply" />
    </VpHeaderActions>

    <!-- List -->
    <VpList
      :per-page="10"
      :columns="columns"
      endpoint="quickReplies"
      :filters.sync="filters"
      :reorder="true"
      class="vp-h-full"
      ref="list"
      :request-payload="{ query: $options.quickReplies }"
      title="Quick Replies"
      @rowClick="
        $router.push({
          name: 'quick-reply',
          params: {
            id: $event.id,
          },
        })
      "
      @reorder="reorder('quickReplies', $event)"
      @refresh="feature.refresh"
      :feature="feature.key"
    >
      <template #empty>
        <VpListEmpty :feature="feature" route="quick-reply" />
      </template>

      <template #filters>
        <VpField label="Store Visibility">
          <VpRadioGroup
            stack
            name="visibility"
            :options="displayOnStoreOptions"
            v-model="filters.shouldDisplayOnStore"
          />
        </VpField>
        <VpListFilterArchived v-model="filters.archived" />
      </template>

      <template #media="{ item }">
        <VpMedia :value="item.medias[0]" />
      </template>

      <template #message="{ item }">
        <LockedItem :item="item" />
        <span class="message-text vp-line-clamp-2">{{ item.message }}</span>
      </template>

      <template #isPinned="{ item }">
        <span class="vp-text-lg">
          {{ item.isPinned ? "📌" : " " }}
        </span>
      </template>
    </VpList>
  </div>
</template>

<script>
import { Document, Help } from "icons/icons.js";
import { mapGetters } from "vuex";
import LockedItem from "components/src/vp-list/locked-item.vue";

import quickReplies from "@/views/crm/quick-replies/collection.gql";

import reorder from "mixins/reorder.js";

export default {
  quickReplies,
  icons: {
    Document,
    Help,
  },
  props: {
    feature: Object,
  },
  components: {
    LockedItem,
  },
  mixins: [reorder],
  data() {
    return {
      filters: {
        archived: false,
        shouldDisplayOnStore: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      checkPermission: "user/checkPermission",
    }),

    displayOnStoreOptions() {
      return [
        { label: "All", value: null },
        { label: "Accessible", value: true },
        { label: "Not Accessible", value: false },
      ];
    },
    columns() {
      return [
        { name: "_index", label: "#", fix: true },
        { name: "media", fix: true, type: "string" },
        { name: "name", sortable: true, fix: true, type: "string" },
        {
          name: "message",
          width: "450px",
          type: "string",
        },
        {
          name: "sent_counter",
          label: "Sent",
          fix: true,
          value(item) {
            return item.sentCounter + " times";
          },
          type: "string",
        },
        { name: "isPinned", label: "Pinned", fix: true, type: "string" },
      ];
    },
  },
};
</script>
